module.exports = __webpack_public_path__ + "static/media/first-aid.aeed41ed.svg";